module.exports = __webpack_public_path__ + "img/we_2.8c5807bb.svg";